import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getVisibleDepreciations,
  getFilters,
  getPagination,
  getIsLoading,
} from 'depreciations/selectors';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';

import * as Depreciations from 'depreciations/components';
import DepreciationRowContainer from 'depreciations/containers/DepreciationRowContainer';
import DepreciationsListHandlers from 'depreciations/containers/DepreciationsListHandlers';

import { toggle } from 'depreciations/actions'; ////////
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions'; ////////

class DepreciationsListContainer extends Component {
  renderRows = () =>
    this.props.depreciations.map((depreciation) => (
      <DepreciationRowContainer
        key={depreciation.id}
        depreciation={depreciation}
        handleToggle={this.handleToggle} ////////
      />
    ));

  handleToggle = (
    id ////////////////////
  ) =>
    this.props
      .toggle(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <DepreciationsListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch,
        handleToggleSearch, // Agregar
      }) => (
        <Depreciations.ListView
          count={this.props.depreciations.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleToggle={this.handleToggle} ////////////////////////
          columnSearch={columnSearch}
          handleToggleSearch={handleToggleSearch}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.renderRows()}
        </Depreciations.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
  depreciations: getVisibleDepreciations(state),
  filters: getFilters(state),
  pagination: getPagination(state),
  isLoading: getIsLoading(state),
});
const mapDispatchToProps = { toggle, error, success }; ///////

export default connect(mapStateToProps, mapDispatchToProps)(DepreciationsListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/containers/DepreciationsListContainer.js